/* eslint-disable react/jsx-wrap-multilines */
import moment from 'moment';
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableMeta,
  MUIDataTableOptions,
  MUISortOptions,
} from 'mui-datatables';
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Launch, History, Refresh } from '@material-ui/icons';

import { Grid, Link, Box, Tooltip, IconButton } from '@material-ui/core';

import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { StatusType } from 'enums/status-type.enum';
import DrawerNative from 'components/DrawerNative';
import ContentHistory from 'components/ContentHistory/ContentHistory';
import { EQueryStringKey } from 'services/QueryString/QueryStringService';
import { setLanguageLabel } from 'pages/labels/languageLabels';
import { ContentExpansion } from 'components/ContentExpansion/ContentExpansion';
import { TitleTranslateTryAgain } from '../../../components/TitleTranslateTryAgain/TitleTranslateTryAgain.compoment';
import { DataRangeFilter } from '../../../components/DataRangeFilter/DataRangeFilter';
import { debounceSearchRender } from '../../../components/DebouncePlugin';
import DrawerContents from '../../../components/DrawerContents';
import Loading from '../../../components/Loading';
import PageError from '../../../components/PageError';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Toast } from '../../../components/Toast';
import {
  GET_TITLES_AS_CONTENTMANAGER,
  GET_TITLE_CONTENT_BY_ID,
  PAUSE_REVIEW,
} from '../../../queries/titleContent';
import {
  GET_ACCOUNT_MANAGERS,
  GET_REVIEWERS_WRITERS_TRANSLATORS,
} from '../../../queries/user';
// eslint-disable-next-line import/no-named-default
import { default as useAlertStyles } from '../../../components/FormContents/components/ActionButtons/styles';
import useStyles from '../../../themes/tableStyle';
import { setStatusLabel, setStatusWPLabel } from '../../labels';
import {
  WAITING,
  APPROVED,
  REPROVED,
  WORKING,
  DONE,
  PREREVISION,
  REVISION,
  WAITPUBLISHING,
  PUBLISHED,
  RETURNTOWRITER,
  REVIEWPAUSED,
} from '../../labels/labelsStatusContent';
import UpdateTitles from './edit';
import MUITableLoading from '../../../components/MUITableLoading/MUITableLoading';
import { UserService } from '../../../services/User/UserService';
import { useUserData } from '../../../hooks/context/userUserData.hook';
import Layout from '../../../components/Layout/Layout';

const Contents: React.FC = () => {
  const location = useLocation();
  const history = useHistory();

  const startRevisionPermittedRoles = ['CONTENTMANAGER', 'REVIEWER'];

  const classes = useStyles();
  const alertClasses = useAlertStyles();

  const [{ role }] = useUserData();
  const sites = UserService.useSitesFromAccess();

  const [writers, setWriters] = useState<IUser[]>([]);
  const [accountManagers, setAccountManagers] = useState([]);
  const [titles, setTitles] = useState<ITitle[]>([]);
  const [filterSites, setFilterSites] = useState<string[]>(sites);
  const [selectedTitleId, setSelectedTitleId] = useState('');
  const [isStartRevision, setIsStartRevision] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [isByPublishPost, setIsByPublishPost] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(
    moment().add(-6, 'days').startOf('day').toDate(),
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    moment().endOf('day').toDate(),
  );
  const [dateTypeFilter, setDateTypeFilter] = useState('Last7Days');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(10);
  const [filterStatus, setFilterStatus] = useState(null);
  const [filterWriter, setFilterWriter] = useState(null);
  const [filterLanguage, setFilterLanguage] = useState<string | null>(null);
  const [filterAccountManager, setFilterAccountManager] = useState(null);
  const [filterSearchText, setFilterSearchText] = useState<string | null>(null);
  const [filterAndSearchPersist, setFilterAndSearchPersist] = useState<any>({
    filterList: [],
    searchText: null,
  });
  const [openLoading, setOpenLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [filterTag, setFilterTag] = useState(null);

  function appendFilterListToColumns(columns: any[], filterList: any[]) {
    filterList.forEach((filter, index) => {
      // eslint-disable-next-line no-param-reassign
      columns[index].options.filterList = filter;
    });
    return columns;
  }

  const [loadTitleById, { data: titleData }] = useLazyQuery(
    GET_TITLE_CONTENT_BY_ID,
    {
      fetchPolicy: 'network-only',
    },
  );

  const [getContents, queryContents] = useLazyQuery(
    GET_TITLES_AS_CONTENTMANAGER,
    {
      variables: {
        sites: filterSites,
        offset: page * limit,
        limit,
        dateStart: selectedStartDate,
        dateEnd: selectedEndDate,
        status: filterStatus,
        writer: filterWriter,
        accountManagerEmail: filterAccountManager,
        searchText: filterSearchText,
        tag: filterTag,
        byPublishPost: isByPublishPost,
        language: filterLanguage,
      },
      fetchPolicy: 'network-only',
    },
  );

  const { error } = queryContents;

  const queryUsers = useQuery(GET_REVIEWERS_WRITERS_TRANSLATORS);
  const queryAccountManagers = useQuery(GET_ACCOUNT_MANAGERS);

  const [pauseReview] = useMutation(PAUSE_REVIEW, {
    onCompleted: () => refetchTitles(),
  });

  useEffect(() => {
    if (queryContents.data) {
      const {
        data: { titlesAsContentManager },
      } = queryContents;
      setTitles(titlesAsContentManager.titles);
      setTotal(titlesAsContentManager.total);
      setPermissions(titlesAsContentManager.permissions);
    }
  }, [queryContents]);

  useEffect(() => {
    if (queryUsers.data) {
      const {
        data: { userListByRole },
      } = queryUsers;
      setWriters(userListByRole);
    }
  }, [queryUsers]);

  useEffect(() => {
    if (queryAccountManagers.data) {
      const {
        data: { userListByRole },
      } = queryAccountManagers;
      setAccountManagers(userListByRole);
      getContents();
    }
  }, [queryAccountManagers, getContents]);

  const updateTitlesTable = (page: number, rowsPerPage: number) => {
    setPage(page);
    setLimit(rowsPerPage);
  };

  const sortTitlesTable = (sortOrder: MUISortOptions) => {
    const { name: field, direction } = sortOrder;

    const clonedTitles = [...titles];

    if (direction === 'asc') {
      clonedTitles.sort((a: any, b: any) => {
        return (a[field] || '').localeCompare(b[field] || '');
      });

      setTitles(clonedTitles);
    } else {
      clonedTitles.sort((a: any, b: any) => {
        return (b[field] || '').localeCompare(a[field] || '');
      });

      setTitles(clonedTitles);
    }
  };

  const startRevisionConfirmAlert = async () => {
    const result = await Swal.fire({
      title: 'Do you want start the revision of this content?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#78001b',
      reverseButtons: true,
      cancelButtonText: 'NO',
      confirmButtonText: 'YES',
      customClass: {
        container: alertClasses.swalDialog,
      },
    });

    return result.value;
  };

  const handleOpenEditContentDrawer = async (
    titleId: string,
    contentStatus?: number,
  ) => {
    const statusToStartRevisionConfirmAlert = [
      StatusType.Revision,
      StatusType.ReviewPaused,
    ];

    if (
      contentStatus &&
      statusToStartRevisionConfirmAlert.includes(contentStatus) &&
      startRevisionPermittedRoles.includes(role) &&
      (await startRevisionConfirmAlert())
    ) {
      setIsStartRevision(true);
    } else {
      setIsStartRevision(false);
    }

    setSelectedTitleId(titleId);
    setShowDrawer(true);

    const params = new URLSearchParams({ [EQueryStringKey.TitleId]: titleId });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const handleRowClick = (dataIndex: number) => {
    const titleId = titles[dataIndex].id;
    const contentStatus = titles[dataIndex].status;

    handleOpenEditContentDrawer(titleId, contentStatus);
  };

  useEffect(() => {
    let mounted = true;

    const titleIdQueryString = new URLSearchParams(location.search).get(
      EQueryStringKey.TitleId,
    );

    if (mounted && titleIdQueryString) {
      loadTitleById({
        variables: {
          id: titleIdQueryString,
        },
      });
    }

    return () => (mounted = false as any);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadTitleById]);

  useEffect(() => {
    const titleIdQueryString = new URLSearchParams(location.search).get(
      EQueryStringKey.TitleId,
    );

    if (titleData && titleIdQueryString && !showDrawer) {
      const titleId = titleData.titleContent.titles[0].id;
      const contentStatus = titleData.titleContent.titles[0].status;

      handleOpenEditContentDrawer(titleId, contentStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleData]);

  const linkTitle = (value: string) => {
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return <Link>{value}</Link>;
  };

  const refetchTitles = async (showBackdrop = true) => {
    if (showBackdrop) setOpenLoading(true);
    queryContents.refetch!();

    if (showBackdrop) {
      setOpenLoading(false);
      Toast('Titles updated successfully!');
    }
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
    const params = new URLSearchParams(location.search);
    params.delete(EQueryStringKey.TitleId);
    history.replace({ pathname: location.pathname, search: params.toString() });

    if (startRevisionPermittedRoles.includes(role) && isStartRevision) {
      pauseReview({ variables: { titleId: selectedTitleId } });
    }
  };

  const refreshList = () => (
    <Tooltip title="Refresh contents">
      <IconButton aria-label="refresh" onClick={() => refetchTitles()}>
        <Refresh />
      </IconButton>
    </Tooltip>
  );

  const FilterDialogFooter = () => <Box width={360} />;

  const options: MUIDataTableOptions = {
    selectableRowsOnClick: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    responsive: 'standard',
    sort: true,
    filter: false,
    pagination: true,
    serverSide: true,
    count: total,
    page,
    rowsPerPage: limit,
    customSearchRender: debounceSearchRender(700),
    // eslint-disable-next-line react/display-name
    customFilterDialogFooter: () => <FilterDialogFooter />,
    onCellClick: (_, cellMeta) => {
      if (cellMeta.colIndex > 0) {
        handleRowClick(cellMeta.dataIndex);
      }
    },
    searchText: filterAndSearchPersist.searchText ?? undefined,
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changeRowsPerPage':
          updateTitlesTable(tableState.page, tableState.rowsPerPage);
          break;
        case 'changePage':
          updateTitlesTable(tableState.page, tableState.rowsPerPage);
          break;
        case 'filterChange':
          updateTitlesTable(tableState.page, tableState.rowsPerPage);
          break;
        case 'sort':
          sortTitlesTable(tableState.sortOrder);
          break;
        case 'search':
          setFilterAndSearchPersist({
            ...filterAndSearchPersist,
            searchText: tableState.searchText,
          });
          setFilterSearchText(tableState.searchText);
          break;
        default:
          break;
      }
    },
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: ' ',
      options: {
        customBodyRender(cell: string, tableMeta: MUIDataTableMeta) {
          const historyPermittedRoles = ['ADMIN', 'CONTENTMANAGER'];

          if (!historyPermittedRoles.includes(role)) return <></>;

          const title = titles.find((title) => title.id === cell);

          return (
            <Box style={{ display: 'flex' }}>
              <DrawerNative
                open={false}
                width="70%"
                title={`Content history - ${tableMeta.rowData[2]}`}
                labelButtonAction={
                  <History
                    style={{
                      marginRight: '8px',
                      marginTop: '3px',
                      width: '20px',
                    }}
                  />
                }
              >
                <ContentHistory titleId={cell} />
              </DrawerNative>

              <TitleTranslateTryAgain
                title={title || ({} as ITitle)}
                refetch={queryContents.refetch!}
              />

              {title?.postUrl && (
                <Link target="_blank" rel="noreferrer" href={title?.postUrl}>
                  <Launch
                    style={{
                      verticalAlign: 'middle',
                      marginRight: '8px',
                      marginTop: '3px',
                      width: '20px',
                    }}
                  />
                </Link>
              )}

              <ContentExpansion
                titleId={cell}
                content={title?.content || ''}
                status={title?.status || 0}
              />
            </Box>
          );
        },
      },
    },
    {
      name: 'title',
      label: 'TITLE',
      options: {
        empty: true,
        filter: true,
        sort: false,
        customBodyRender: linkTitle,
      },
    },
    {
      name: 'titleContent',
      label: 'TITLE CONTENT',
      options: {
        empty: true,
        filter: true,
        sort: false,
      },
    },
    {
      name: 'language',
      label: 'LANGUAGE',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (language: string) => setLanguageLabel(language),
      },
    },
    {
      name: 'tag',
      label: 'TAG',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (tag: string) => tag?.toUpperCase(),
      },
    },
    {
      name: 'status',
      label: 'STATUS',
      options: {
        display: true,
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({ className: classes.statusLabel }),
        filterOptions: {
          logic: (location: any, filters: any[]) => {
            if (location === filters[0]) return true;
            return false;
          },
          names: [
            WAITING,
            APPROVED,
            REPROVED,
            WORKING,
            DONE,
            PREREVISION,
            REVISION,
            WAITPUBLISHING,
            PUBLISHED,
            RETURNTOWRITER,
            REVIEWPAUSED,
          ],
        },
        customBodyRender: (status: number, meta: MUIDataTableMeta) => {
          const dStatus = meta.rowData[meta.columnIndex];
          const publishPost = meta.rowData[16];

          return setStatusLabel(
            moment(publishPost).isAfter(new Date()) &&
              dStatus === StatusType.WaitPublish
              ? StatusType.Scheduled
              : status,
          );
        },
      },
    },
    {
      name: 'createdAt',
      label: 'CREATED AT',
      options: {
        display: false,
        filter: false,
        sort: false,
        customBodyRender(createdAt?: Date) {
          return createdAt ? moment(createdAt).format('YYYY-MM-DD') : '';
        },
      },
    },
    {
      name: 'writerId',
      label: 'WRITER',
      options: {
        display: true,
        filter: false,
        sort: false,
        filterOptions: {
          names: writers.map((writer) => writer.name),
        },
        customBodyRender: (writerId: string) => {
          if (writerId && writers) {
            const writer = writers.find((writer) => writer.id === writerId);
            return writer ? writer.name : '';
          }
          return '';
        },
      },
    },
    {
      name: 'comments',
      label: 'COMMENTS',
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: 'suggestedKeywords',
      label: 'SUGGESTED KEYWORDS',
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: 'researchLinks',
      label: 'RESEARCH LINKS',
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: 'statusAtWP',
      label: 'STATUS WP',
      options: {
        display: role === 'ADMIN',
        filter: false,
        sort: false,
        customBodyRender: (statusAtWP: number) => setStatusWPLabel(statusAtWP),
      },
    },
    {
      name: 'siteDomain',
      label: 'SITE',
      options: {
        display: true,
        filter: false,
        sort: false,
        filterOptions: {
          names: sites,
        },
      },
    },
    {
      name: 'accountManager',
      label: 'ACCOUNT MANAGER',
      options: {
        display: true,
        filter: false,
        sort: false,
        filterOptions: {
          names: accountManagers.map(
            (accountManager: IAccountManager) => accountManager.name,
          ),
        },
        customBodyRender: (accountManager: IAccountManager) => {
          return accountManager?.name || '';
        },
      },
    },
    {
      name: 'publishedBy',
      label: 'PUBLISHED BY',
      options: {
        filter: false,
        display: false,
        sort: false,
      },
    },
    {
      name: 'editedBy',
      label: 'EDITED BY',
      options: {
        filter: false,
        display: false,
        sort: false,
      },
    },
    {
      name: 'publishPost',
      label: 'PUBLISH POST',
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender(publishPost?: Date) {
          return publishPost
            ? moment(publishPost).utc().format('YYYY-MM-DD')
            : '';
        },
      },
    },
    {
      name: 'deadline',
      label: 'DEADLINE',
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender(deadline?: Date) {
          return deadline ? moment(deadline).utc().format('YYYY-MM-DD') : '';
        },
      },
    },
  ];

  return (
    <Layout>
      <Loading openLoading={openLoading} />
      <DrawerContents
        title="Edit Titles"
        statusDrawer={showDrawer}
        setStatusDrawer={setShowDrawer}
        onCloseDrawer={handleCloseDrawer}
      >
        <UpdateTitles
          titleId={selectedTitleId}
          setShowDrawer={setShowDrawer}
          isStartRevision={isStartRevision}
          refetchContentList={queryContents.refetch}
        />
      </DrawerContents>

      <Grid container spacing={0}>
        <Grid item xs={4}>
          <PageTitle title="Contents" />
        </Grid>
        <Grid item xs={8}>
          <DataRangeFilter
            showIsPublishPostFilter
            isByPublishPost={isByPublishPost}
            setIsByPublishPost={setIsByPublishPost}
            selectedStartDate={selectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            selectedEndDate={selectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
            dateTypeFilter={dateTypeFilter}
            setDateTypeFilter={setDateTypeFilter}
            filterStatus={filterStatus}
            setFilterStatus={setFilterStatus}
            writers={writers}
            accountManagers={accountManagers}
            filterWriter={filterWriter}
            setFilterWriter={setFilterWriter}
            filterAccountManager={filterAccountManager}
            setFilterAccountManager={setFilterAccountManager}
            filterSite={filterSites}
            setFilterSite={setFilterSites}
            sites={sites}
            setPage={setPage}
            permissions={permissions}
            filterTag={filterTag}
            setFilterTag={setFilterTag}
            loading={queryContents.loading}
            filterLanguage={filterLanguage}
            setFilterLanguage={setFilterLanguage}
          />
        </Grid>
      </Grid>
      {error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {queryContents.loading ? (
              <MUITableLoading
                withRefresh
                hasFilter={false}
                selectable="none"
                columns={[
                  'TITLE',
                  'TITLE CONTENT',
                  'LANGUAGE',
                  'TAG',
                  'STATUS',
                  'WRITER',
                  'STATUS WP',
                  'SITE',
                  'ACCOUNT MANAGER',
                  'PUBLISH POST',
                ]}
              />
            ) : (
              <MUIDataTable
                title={refreshList()}
                data={titles}
                columns={appendFilterListToColumns(
                  columns,
                  filterAndSearchPersist.filterList,
                )}
                options={options}
              />
            )}
          </Grid>
        </Grid>
      )}
    </Layout>
  );
};

export default Contents;
